module.exports = __webpack_public_path__ + "img/success.79341c27.svg";